// import React, { useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import styled from "styled-components";
// import img1 from "./ImagesDashboard/signed.png";
// import total_img from "./ImagesDashboard/total_contract.png";
// import approval from "./ImagesDashboard/right.png";
// import review from "./ImagesDashboard/review.png";
// import signed from "./ImagesDashboard/signed.png";
// import cross from "./ImagesDashboard/approval_status.png";
// import renewals from "./ImagesDashboard/renewals.png";
// import tasks from "./ImagesDashboard/tasks.png";
// import e_stamps from "./ImagesDashboard/e_stamps.png";
// import signed_status from "./ImagesDashboard/signing_status.png"
// import { useSelector } from "react-redux";
// import { selectUserData } from "../redux/selectors";

// const COLORS = {
//   primaryDark: "rgb(248,244,252)",
//   primaryLight: "#f8f4fc",
// };

// const MenuLabel = styled.label`
//   background-color: ${COLORS.primaryLight};
//   position: fixed;
//   top: 6rem;
//   right: 2rem;
//   border-radius: 50%;
//   height: 7rem;
//   width: 7rem;
//   cursor: pointer;
//   z-index: 1000;
//   box-shadow: 0 1rem 3rem rgba(182, 237, 200, 0.3);
//   text-align: center;
// `;

// const NavBackground = styled.div`
//   position: fixed;
//   top: 6.5rem;
//   right: 6.5rem;
//   background-image: radial-gradient(
//     ${COLORS.primaryDark},
//     ${COLORS.primaryLight}
//   );
//   height: 4rem;
//   width: 0.25vw;
//   // border: 2px solid red;
//   border-radius: 50%;
//   // border: 2px solid red;
//   z-index: 600;
//   transform: ${(props) => (props.clicked ? "scale(80)" : "scale(0)")};
//   transition: transform 0.8s;
// `;

// const Icon = styled.span`
//   position: relative;
//   background-color: ${(props) => (props.clicked ? "transparent" : "black")};
//   width: 3rem;
//   height: 2px;
//   // border: 2px solid red;
//   display: inline-block;
//   margin-top: 3.5rem;
//   transition: all 0.3s;

//   &::before,
//   &::after {
//     content: "";
//     background-color: black;
//     width: 3rem;
//     height: 2px;
//     display: inline-block;

//     position: absolute;
//     left: 0;
//     transition: all 0.3s;
//   }

//   &::before {
//     top: ${(props) => (props.clicked ? "0" : "-0.8rem")};
//     transform: ${(props) => (props.clicked ? "rotate(135deg)" : "rotate(0)")};
//   }

//   &::after {
//     top: ${(props) => (props.clicked ? "0" : "0.8rem")};

//     transform: ${(props) => (props.clicked ? "rotate(-135deg)" : "rotate(0)")};
//   }

//   ${MenuLabel}:hover &::before {
//     top: ${(props) => (props.clicked ? "0" : "-1rem")};
//   }
//   ${MenuLabel}:hover &::after {
//     top: ${(props) => (props.clicked ? "0" : "1rem")};
//   }
// `;

// const Navigation = styled.nav`
//   height: 100vh;
//   position: fixed;
//   top: 0;
//   right: 0;
//   z-index: 600;
//   width: ${(props) => (props.clicked ? "20%" : "0")};
//   opacity: ${(props) => (props.clicked ? "1" : "0")};

//   transition: width 0.8s, opacity 0.8s;
// `;
// const GlassyButton = styled.div`
//   transition: transform 0.3s ease-in-out;
//   cursor: pointer;

//   &:hover {
//     transform: scale(1.25);
//   }
// `;

// const List = styled.ul`
//   position: absolute;
//   list-style: none;
//   top: 50%;
//   left: 50%;
//   // border: 2px solid red;
//   transform: translate(-50%, -50%);
//   text-align: center;
//   width: 70%;
// `;
// const ItemLink = styled(NavLink)`
//   display: inline-block;
//   font-size: 1.5rem;
//   font-weight: 300;
//   text-decoration: none;
//   color: black;
//   padding: 1rem 2rem;

//   background-image: linear-gradient(
//     120deg,
//     transparent 0%,
//     transparent 50%,
//     #fff 50%
//   );
//   background-size: 240%;
//   transition: all 0.4s;

//   &:hover,
//   &:active {
//     background-position: 100%;
//     color: #288ce4;
//     transform: translateX(1rem);
//   }
// `;

// function HamburgerMenuAgreements() {
//   const [click, setClick] = useState(false);
//   const handleClick = () => setClick(!click);
//   const currentUser = useSelector(selectUserData) || {};
//   const loginAs = currentUser.loginAs;
//   const url = window.location.href;
//   const parts = url.split("/");
//   const ending = parts[parts.length - 1];
//   const itemTitle = ending
//     .split("-")
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(" ");
//   // console.log(itemTitle);
//   const [BoxData, setBoxData] = useState(
//     [
//       {
//         title: "total agreements",
//         icon: null,
//         value: "760",
//         color: "red-400",
//         imgSrc: total_img,
//       },
//       loginAs.id === 1 ||
//       loginAs.id === 2 ||
//       loginAs.id === 4 ||
//       loginAs.id === 5
//         ? {
//             title: "review status",
//             icon: null,
//             value: "294",
//             color: "blue-900",
//             imgSrc: review,
//           }
//         : null,
//       loginAs.id === 1 ||
//       loginAs.id === 2 ||
//       loginAs.id === 4 ||
//       loginAs.id === 6
//         ? {
//             title: "approval status",
//             icon: null,
//             value: "265",
//             color: "purple-900",
//             imgSrc: cross,
//           }
//         : null,
//       loginAs.id === 1 ||
//       loginAs.id === 2 ||
//       loginAs.id === 4 ||
//       loginAs.id === 7
//         ? {
//             title: "signature status",
//             icon: null,
//             value: "256",
//             color: "green-900",
//             imgSrc: signed_status,
//           }
//         : null,

//       loginAs.id === 1 || loginAs.id === 2 || loginAs.id === 4
//         ? {
//             title: "signed",
//             icon: null,
//             value: "456",
//             color: "pink-900",
//             imgSrc: signed,
//           }
//         : null,
//         loginAs.id === 1 || loginAs.id === 2 || loginAs.id === 4
//         ?{
//         title: "renewals",
//         icon: null,
//         value: "760",
//         color: "red-400",
//         imgSrc: renewals,
//       }: null,
//       // {
//       //   title: "tasks",
//       //   icon: null,
//       //   value: "294",
//       //   color: "blue-900",
//       //   imgSrc: tasks,
//       // },
//       // loginAs.id === 1 || loginAs.id === 2 || loginAs.id === 4
//       //   ?{
//       //   title: "e-stamps",
//       //   icon: null,
//       //   value: "256",
//       //   color: "green-900",
//       //   imgSrc: e_stamps,
//       // }: null,
//     ].filter(item => item && item.title !== itemTitle)
//   );
  
//   const navigate = useNavigate();
//   const handleBoxClick = (title) => {
//     const currentPath = "/app/agreements_manager";
//     if (title === "e-stamps") {
//       window.location.href = "https://www.emsigner.com/Areas/login?ReturnUrl=%2feMsecure%2feStamping%2feStampingSummary";
//     } else if (title === "tasks") {
//       navigate(`${currentPath}/tasks/pending`);
//     } else {
//     const newPath = `${currentPath}/${title.toLowerCase().replace(/\s/g, "-")}`;
//     navigate(newPath);
//     }
//   };

//   return (
//     <>
//       <div
//         className="flex"
        
//       >
//         {" "}
//         {BoxData.map((item, index) => (
//           <GlassyButton
//             key={index}
//             onClick={() => handleBoxClick(item.title)}
//             to={`/app/agreements_manager/${item.title
//               .toLowerCase()
//               .replace(/\s/g, "-")}`}
//           >
//             <img
//               src={item.imgSrc}
//               alt="Button Image"
//               className="w-9 h-9 m-2"
//               title={item.title}
//             />
//           </GlassyButton>
//         ))}
//       </div>
//     </>
//   );
// }

// export default HamburgerMenuAgreements;

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../redux/selectors";
import styled from "styled-components";
import { 
  HiOutlineDocumentDuplicate, 
  HiOutlineSearchCircle, 
  HiOutlineUserGroup, 
  HiOutlinePencilAlt, 
  HiOutlineBadgeCheck, 
  HiOutlineRefresh, 
  HiOutlineTicket, 
  HiOutlineClipboardList
} from "react-icons/hi";

const THEME_BLUE = "#077CA5";
const BG_GRAY = "#edeff0";

const GlassyButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0.25rem;
  cursor: pointer;
  border-radius: 6px;
  border: 1.5px solid ${THEME_BLUE};
  background-color: ${(props) => (props.isActive ? THEME_BLUE : BG_GRAY)};
  transition: all 0.2s ease-in-out;
  position: relative;

  &:hover {
    transform: ${(props) => (props.isActive ? "none" : "translateY(-2px)")};
    background-color: ${(props) => (props.isActive ? THEME_BLUE : "#adb9bf")};
  }

  /* Tooltip below icon */
  &::after {
    content: "${(props) => props.tooltip || ""}";
    position: absolute;
    bottom: -2.5rem; /* below the icon */
    left: 50%;
    transform: translateX(-50%);
    background-color: ${THEME_BLUE};
    color: white;
    font-size: 0.65rem; /* smaller text */
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
    z-index: 10;
  }

  &:hover::after {
    opacity: 1;
  }
`;

function HamburgerMenuAgreements() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser.loginAs || { id: 1 };

const menuItems = [
  { title: "All Contracts", route: "total-agreements", icon: HiOutlineDocumentDuplicate },
  [1, 2, 4, 5].includes(loginAs.id) && { title: "Review Stage", route: "review-status", icon: HiOutlineSearchCircle },
  [1, 2, 4, 6].includes(loginAs.id) && { title: "Approval Stage", route: "approval-status", icon: HiOutlineUserGroup },
  [1, 2, 4, 7].includes(loginAs.id) && { title: "Signature Stage", route: "signature-status", icon: HiOutlinePencilAlt },
  [1, 2, 4].includes(loginAs.id) && { title: "Signed", route: "signed", icon: HiOutlineBadgeCheck },
  [1, 2, 4].includes(loginAs.id) && { title: "Renewals", route: "renewals", icon: HiOutlineRefresh },
    // { title: "Tasks", route: "tasks", icon: HiOutlineClipboardList },
  // [1, 2, 4].includes(loginAs.id) && { title: "e-Stamps", route: "e-stamps", icon: HiOutlineTicket },
].filter(Boolean);

const handleBoxClick = (item) => {
  const base = "/app/agreements_manager";
  if (item.route === "e-stamps") {
    window.location.href = "https://www.emsigner.com/Areas/login?ReturnUrl=%2feMsecure%2feStamping%2feStampingSummary";
  } else {
    navigate(`${base}/${item.route}`); // now "review-status", not "review status"
  }
};

const checkActive = (item) => {
  return location.pathname.includes(item.route); // compare with hyphenated route
};

  return (
    <div className="flex flex-row items-center justify-end">
      {menuItems.map((item, index) => {
        const isActive = checkActive(item);
        const IconComponent = item.icon;

        return (
          <GlassyButton
            key={index}
            onClick={() => handleBoxClick(item)}
            isActive={isActive}
            tooltip={item.title}
          >
            <IconComponent
              size={20}
              color={isActive ? "#FFFFFF" : THEME_BLUE}
            />
          </GlassyButton>
        );
      })}
    </div>
  );
}

export default HamburgerMenuAgreements;

